'use client';

import React, { type ReactElement, useState } from 'react';

import { type MultiLevelMenuItem } from '@/common/types/multi-level-menu.type';
import { type AllProductsQueryParams } from '@/common/types/product.type';
import { type FilteredDataType } from '@/features/store/types/filter.type';

import { type VendorItemResponse } from '@/common/apis/storefronts/v1/get-vendor.api';
import SearchBox from '@/common/components/input/search-box.component';

import FilterHeader from './filter-header.component';
import Products from './products.component';

interface Props {
  collectionId: number;
  vendorInfo?: VendorItemResponse;
  categoryListData: MultiLevelMenuItem[];
  filteredData: FilteredDataType;
  openSearchBox: boolean;
  searchBarHandler: (value: boolean) => void;
  searchHandler: (value: string) => void;
  searchBoxCloseHandler: (value: boolean) => void;
  payloadSetter: (payload: AllProductsQueryParams) => void;
  payload: AllProductsQueryParams;
}

export default function Body({
  collectionId,
  vendorInfo,
  categoryListData,
  filteredData,
  openSearchBox,
  payloadSetter,
  payload,
  searchBarHandler,
  searchBoxCloseHandler,
  searchHandler,
}: Props): ReactElement {
  const [, setOpen] = useState(false);

  const activeVendor = vendorInfo?.vendorStatus?.toLocaleUpperCase();

  return (
    <div className=" mt-4 flex  h-full w-full flex-col gap-y-4 px-4">
      {activeVendor === 'ACTIVE' && !openSearchBox && (
        <FilterHeader
          setOpen={setOpen}
          filtered={false}
          openSearch={searchBarHandler}
          categoryList={categoryListData}
          payloadSetter={payloadSetter}
          filteredData={filteredData}
        />
      )}
      {openSearchBox && (
        <div className="mt-2 animate-enterLeft">
          <SearchBox
            onSearch={(value) => {
              searchHandler(value);
            }}
            placeholder="جستجو در میان محصولات"
            className="search-store"
            withButton
            closeHandler={searchBoxCloseHandler}
          />
        </div>
      )}
      {/* {payload && (
        <FilterTags
          payload={payload}
          setPayload={setPayload}
          filteredData={filteredData}
          setFilteredData={setFilteredData}
        />
      )} */}

      <div className="relative h-full w-full overflow-y-scroll">
        <div className="w-full overflow-hidden ">
          <Products queryParams={payload} collectionId={collectionId} />
        </div>
      </div>
    </div>
  );
}
